import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteIssuesPrioritiesListError, deleteIssuesPrioritiesListSuccess,

    getIssuesPrioritiesListError,
    getIssuesPrioritiesListSuccess
} from './actions';
import {
    ISSUES_PRIORITIES_DELETE_ITEMS, ISSUES_PRIORITIES_GET_LIST, ISSUES_PRIORITIES_INITIALIZE_LIST
} from './actions_def';


const apiUrl = servicePath;

const initializeIssuesPrioritiesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/priorities/initialize',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* initializeIssuesPrioritiesList({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getIssuesPrioritiesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(initializeIssuesPrioritiesListRequest, payload);
            yield put(getIssuesPrioritiesListSuccess(response));
        } catch (error) {
            yield put(getIssuesPrioritiesListError(error));
        }
    }
}

const getIssuesPrioritiesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/priorities/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesPrioritiesList({ payload }) {
    // // console.log(payload);;

    if (!payload) {
        yield put(getIssuesPrioritiesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(getIssuesPrioritiesListRequest, payload);
            yield put(getIssuesPrioritiesListSuccess(response));
        } catch (error) {
            yield put(getIssuesPrioritiesListError(error));
        }
    }
}


const deleteIssuesPrioritiesListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _priority = 1;
        switch (items.priority) {
            case "PENDING": _priority = 1; break;
            default: _priority = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/priorities/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.priority === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.priority === "success" || response.data.priority === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.priority)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesPrioritiesList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteIssuesPrioritiesListRequest, payload);
        yield put(deleteIssuesPrioritiesListSuccess(response));
    } catch (error) {
        yield put(deleteIssuesPrioritiesListError(error));
    }
}



export function* watchGetList() {
    yield takeEvery(ISSUES_PRIORITIES_GET_LIST, getIssuesPrioritiesList);
}

export function* watchInitializeList() {
    yield takeEvery(ISSUES_PRIORITIES_INITIALIZE_LIST, initializeIssuesPrioritiesList);
}

export function* watchDeleteItems() {
    yield takeEvery(ISSUES_PRIORITIES_DELETE_ITEMS, deleteIssuesPrioritiesList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetList),
        fork(watchInitializeList),
        fork(watchDeleteItems),
    ]);
}
